import { render } from "./index.vue?vue&type=template&id=f5817b58&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f5817b58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f5817b58"

export default script